export default function pageLoaderReducer(state = {}, action) {
  switch (action.type) {
    case 'SET_LOADING': {
      return { ...state, isLoading: action.isLoading }
    }
    default: {
      return state
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/PageLoader/reducer.js